import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { featuredArtists } from '@/mocks/artists';

const avatarColors = [
  'bg-amber-500',
  'bg-rose-500',
  'bg-emerald-500',
  'bg-violet-500',
  'bg-orange-500',
  'bg-teal-500',
];

export default function FeaturedArtistsSection() {
  const { t } = useTranslation('home');

  return (
    <section className="w-full py-16 md:py-24 px-6 md:px-10 lg:px-16 bg-gray-50">
      <div className="mb-10 md:mb-14">
        <span className="inline-flex items-center px-4 py-1.5 text-xs font-medium text-gray-700 border border-gray-300 rounded-full mb-4 md:mb-6">
          {t('featuredArtists.label')}
        </span>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight max-w-xl">
          {t('featuredArtists.title')}
          <br />
          {t('featuredArtists.titleLine2')}
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {featuredArtists.map((artist, index) => (
          <Link
            key={artist.id}
            to={`/artista/${artist.id}`}
            className="group bg-white rounded-2xl md:rounded-3xl p-4 md:p-6 hover:shadow-lg transition-all duration-300"
          >
            <div className="flex items-start gap-3 md:gap-4">
              <div className={`w-12 h-12 md:w-14 md:h-14 flex-shrink-0 rounded-full ${avatarColors[index % avatarColors.length]} flex items-center justify-center overflow-hidden`}>
                <img
                  src={artist.avatarUrl}
                  alt={artist.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-bold text-gray-900 group-hover:text-amber-700 transition-colors">
                  {artist.name}
                </h3>
                <p className="text-xs text-gray-400 mt-0.5 flex items-center gap-1">
                  <i className="ri-music-2-line text-amber-500"></i>
                  {artist.genre}
                </p>
              </div>
            </div>

            <div className="mt-4 md:mt-5">
              <div className="relative aspect-[4/3] rounded-xl md:rounded-2xl overflow-hidden mb-4">
                <img
                  src={artist.imageUrl}
                  alt={artist.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center px-2.5 py-1 text-xs font-medium bg-white/90 backdrop-blur-sm text-gray-700 rounded-full">
                    {artist.category}
                  </span>
                </div>
              </div>
              <p className="text-xs md:text-sm text-gray-500 leading-relaxed line-clamp-3">
                "{artist.bio}"
              </p>
              <div className="mt-3 flex flex-wrap gap-1.5">
                {artist.eventTypes.slice(0, 2).map((et) => (
                  <span key={et} className="px-2 py-0.5 text-xs bg-gray-100 text-gray-600 rounded-full">
                    {et}
                  </span>
                ))}
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="mt-8 md:mt-10 flex justify-center">
        <Link
          to="/artistas"
          className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium text-gray-700 border border-gray-200 rounded-full hover:bg-gray-900 hover:text-white hover:border-gray-900 transition-all whitespace-nowrap"
        >
          {t('featuredArtists.viewAll')}
          <i className="ri-arrow-right-line text-sm"></i>
        </Link>
      </div>
    </section>
  );
}